"use client";

import { createContext, useContext } from "react";
import { DEFAULT_THEME, type ThemeId } from "./registry";

const ThemeContext = createContext<ThemeId>(DEFAULT_THEME);

/**
 * Makes the server-resolved theme readable from client components.
 *
 * Most theming should go through CSS — a `[data-theme="…"]` rule beats reading
 * this and branching in JS. Use it only where CSS genuinely cannot reach:
 * swapping an <Image src>, an SVG `fill` attribute, or a prop on a component
 * that renders its own colours.
 */
export function ThemeProvider({
	theme,
	children,
}: {
	theme: ThemeId;
	children: React.ReactNode;
}) {
	return (
		<ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
	);
}

export const useTheme = (): ThemeId => useContext(ThemeContext);

/** Convenience for the common "is the campaign on?" check. */
export const useIsLaunchTheme = (): boolean => useTheme() === "launch";
